export const FILE_NAME_LENGTH_LIMIT = 40;
export const PREVIEW_FILE_NAME_LENGTH_LIMIT = 35;
export const DETAILS_FILE_NAME_LENGTH_LIMIT = 55;
